import ApiService from "@/api";
import { PaginationResponseModel, QueueRelationModel } from "@/components/task-forms/models";
import { ResponseModel } from "@/models";
import {
  mapAddQueueRelationRequest,
  mapGetQueuesRequest,
  mapGetQueuesResponse,
  mapRemoveQueueRelationRequest,
} from "./AdapterServiceMappers";

/**Сервис для использования api */
export class AdapterService {
  /**APi сервис */
  api = new ApiService();

  /**Поиск очередей */
  getQueues(projectId: number, filter: { Search: string; Skip: number; Take: number }) {
    return new Promise<PaginationResponseModel<QueueRelationModel[]>>(async (resolve) => {
      let result = new PaginationResponseModel<QueueRelationModel[]>();

      await this.api.Main.ProjectQueueTaskService.getListByProjectIdAsync(
        mapGetQueuesRequest(projectId, filter),
      )
        .then((response) => {
          result = mapGetQueuesResponse(response, projectId);
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getQueues", e);
          return resolve(result);
        });
    });
  }
  /**Добавление связанной очереди */
  addQueueRelation(taskId: number, queueId: string) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.ProjectTaskSaveService.addQueueRelationAsync(
        mapAddQueueRelationRequest(taskId, queueId),
      )
        .then((response) => {
          result.Value = !!response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR addQueueRelation", e);
          return resolve(result);
        });
    });
  }
  /**Удаление связанной очереди */
  removeQueueRelation(taskId: number, queueId: string) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      let result = new ResponseModel<boolean>();

      await this.api.Main.ProjectTaskSaveService.removeQueueRelationAsync(
        mapRemoveQueueRelationRequest(taskId, queueId),
      )
        .then((response) => {
          result.Value = !!response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR removeQueueRelation", e);
          return resolve(result);
        });
    });
  }
}
